import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { Select, SelectableOption } from '@moda/om';
import { LineItem } from '../../../hooks/useCart/cart.rest';
import './LineItemSizeSelector.scss';

type Props = {
  item: LineItem;
  onChange: (skuId: number) => void;
};

export const LineItemSizeSelector: React.FC<Props> = ({
  item: {
    type,
    attributes: { skuId, inventory, isProductAvailable, error }
  },
  onChange
}) => {
  const handleChange = useCallback((id: string) => skuId !== Number(id) && onChange(Number(id)), [
    onChange,
    skuId
  ]);

  const selectedSkuId = useMemo(
    () => (inventory.some(({ id }) => id === skuId) ? skuId : inventory[0].id),
    [inventory, skuId]
  );

  const sizes: SelectableOption[] = useMemo(
    () =>
      inventory.map(({ size, id, disabled }) => ({
        label: size,
        value: String(id),
        disabled
      })),
    [inventory]
  );

  return (
    <Select
      className={classNames('LineItemSizeSelector', {
        'LineItemSizeSelector--error': error?.type === 'SHORT_SIZE_SOLD_OUT_MESSAGE'
      })}
      disabled={inventory.length < 2 || (type === 'cart_items' && !isProductAvailable)}
      options={sizes}
      onChange={handleChange}
      value={`${selectedSkuId}`}
      label="Size"
      data-testid="lineItemSizeSelector"
    />
  );
};
